import React from 'react';
import { Box, Typography } from '@mui/material';
import { Star } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../styles/constants';

interface RatingSummaryProps {
  averageRating: number;
  totalReviews: number;
}

const RatingSummary: React.FC<RatingSummaryProps> = ({ averageRating, totalReviews }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#F6F8F8',
        borderRadius: '16px',
        padding: '24px',
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        alignSelf: 'stretch',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <Box
            sx={{
              width: '48px',
              height: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Star
              sx={{
                fontSize: 48,
                color: '#AC654D',
              }}
            />
          </Box>
          <Typography
            sx={{
              fontFamily: DESIGN_TOKENS.typography.fontFamily,
              fontSize: '28px',
              fontWeight: 700,
              lineHeight: '32.2px',
              letterSpacing: '-0.28px',
              color: '#000000',
            }}
          >
            {averageRating.toFixed(1)}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontFamily: DESIGN_TOKENS.typography.fontFamily,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '22.4px',
            color: '#000000',
          }}
        >
          Average rating
        </Typography>
      </Box>
      
      <Typography
        sx={{
          fontFamily: DESIGN_TOKENS.typography.fontFamily,
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '22.4px',
          color: '#000000',
        }}
      >
        Based on {totalReviews} reviews
      </Typography>
    </Box>
  );
};

export default RatingSummary;


